import type { BlockedByCustomer } from "entities/domain/conversations/conversation-domain";
import { convertToChannelGroup } from "util/constants";

export default class CustomerChannelDomain {
  id?: string;

  type: string;

  handle: string;

  displayHandle?: string;

  isActive: boolean;

  isSubscribed: boolean;

  isBlocked: boolean;

  // The blocked contact closing this channel (this contact or one sharing the
  // number). Separate from isBlocked, the per-channel block.
  blockedByCustomer: BlockedByCustomer | null;

  getChannelGroup(): string {
    return convertToChannelGroup(this.type);
  }

  getDisplayHandle(): string {
    return this.displayHandle || this.handle;
  }

  getDisplayChannelName(): string {
    switch (this.type) {
      case "sms":
        return "SMS";
      case "whatsapp":
        return "WhatsApp";
      case "facebook":
        return "Facebook messenger";
      case "instagram":
        return "Instagram";
      case "email":
        return "Email";
      default:
        return "";
    }
  }

  getMarketingStatusDisplay(): string {
    switch (this.isSubscribed) {
      case true:
        return "Subscribed";
      case false:
        return "Unsubscribed";
      default:
        return "-";
    }
  }

  constructor(
    id: string | undefined,
    type: string,
    handle: string,
    displayHandle: string | undefined,
    isActive: boolean,
    isSubscribed: boolean,
    isBlocked: boolean = false,
    blockedByCustomer: BlockedByCustomer | null = null
  ) {
    this.id = id;
    this.type = type;
    this.handle = handle;
    this.displayHandle = displayHandle;
    this.isActive = isActive;
    this.isSubscribed = isSubscribed;
    this.isBlocked = isBlocked;
    this.blockedByCustomer = blockedByCustomer;
  }
}
